import { useMutation, useQueryClient } from 'react-query';
import {
  OpenAPI,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto,
  CancelablePromise,
} from '@wealthlane/api-services/wealthlane-award-service';
import axios from 'axios';

export interface FairValueByVestingDateUpsertDto {
  awardType?: string | null;
  awardId?: string;
  vestingDateId?: string;
  companyId?: string;
  tenantId?: string | null;
  fairValuePerShare?: number | null;
  expenseDate?: string | null;
  marketValue?: number | null;
  marketValueType?: string | null;
  expectedLife?: number | null;
  expectedLifeValuationType?: string | null;
  volatility?: number | null;
  volatilityValuationType?: string | null;
  riskFreeRate?: number | null;
  riskFreeRateValuationType?: string | null;
  expectedAnnualDividendYield?: number | null;
  expectedAnnualDividendYieldValuationType?: string | null;
}

const upsertFairValueByVestingDate = (
  requestBody: FairValueByVestingDateUpsertDto
  // eslint-disable-next-line camelcase
): CancelablePromise<Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto> => {
  return new CancelablePromise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${OpenAPI.BASE}/api/award/api/app/fair-value/upsert-fair-value-by-vesting-date`,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${OpenAPI.TOKEN ?? ''}`,
            ...(typeof OpenAPI.HEADERS === 'object' ? OpenAPI.HEADERS : {}),
          },
        }
      );
      resolve(response.data);
    } catch (error: any) {
      reject(error?.response?.data ?? error);
    }
  });
};

const useUpsertFairValueByVestingDate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  options?: {
    onSuccess?: () => void;
    onError?: (error: any) => void;
  }
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: FairValueByVestingDateUpsertDto) => {
      return await handleRequest(upsertFairValueByVestingDate(payload));
    },
    {
      onSuccess: () => {
        // queryClient.invalidateQueries('getFairValueByVestingDate');
        options?.onSuccess?.();
      },
      onError: (error: any) => {
        options?.onError?.(error);
      },
    }
  );
};

export { upsertFairValueByVestingDate };
export default useUpsertFairValueByVestingDate;
